import { emailField, passwordField } from "./field-builders";
import type { TAnyTranslationFunction } from "./types";

export const emailSchema = (
  t: TAnyTranslationFunction,
): ReturnType<typeof emailField> =>
  emailField({
    invalidMessage: t("auth:email.error.invalid"),
  });

export const passwordSchema = (
  t: TAnyTranslationFunction,
): ReturnType<typeof passwordField> =>
  passwordField({
    requiredMessage: t("auth:password.error.required"),
    minLengthMessage: t("auth:password.error.min_length"),
    maxLengthMessage: t("auth:password.error.max_length"),
    patternMessage: t("auth:password.error.regex"),
  });
